import { Map } from "immutable"

import { KNOWLEDGE_LIST_REQUEST as LIST_REQUEST } from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

export const defaultSearchCriteria = Map({
    title: ""
})

export default buildPagingReducer(
    {
        LIST_REQUEST
    },
    defaultSearchCriteria
)
